var _path, _rect, _path2, _path3, _path4, _rect2, _path5, _path6, _path7, _path8, _path9, _rect3, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15 59h-12c-1.105 0-2-.895-2-2v-1c0-1.105.895-2 2-2v-1h12v1c1.105 0 2 .895 2 2v1c0 1.105-.895 2-2 2z",
    fill: "#f4ad3b"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#ffc33e",
    height: 5,
    rx: 2,
    width: 16,
    x: 1,
    y: 49
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m36 59h-12c-1.105 0-2-.895-2-2v-1c0-1.105.895-2 2-2v-1h12v1c1.105 0 2 .895 2 2v1c0 1.105-.895 2-2 2z",
    fill: "#f4ad3b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m36 54h-12c-1.105 0-2-.895-2-2v-1c0-1.105.895-2 2-2v-1h12v1c1.105 0 2 .895 2 2v1c0 1.105-.895 2-2 2z",
    fill: "#ffc33e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m36 49h-12c-1.105 0-2-.895-2-2v-1c0-1.105.895-2 2-2v-1h12v1c1.105 0 2 .895 2 2v1c0 1.105-.895 2-2 2z",
    fill: "#f4ad3b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#ffc33e",
    height: 5,
    rx: 2,
    width: 16,
    x: 22,
    y: 39
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m57 59h-12c-1.105 0-2-.895-2-2v-1c0-1.105.895-2 2-2v-1h12v1c1.105 0 2 .895 2 2v1c0 1.105-.895 2-2 2z",
    fill: "#f4ad3b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m57 54h-12c-1.105 0-2-.895-2-2v-1c0-1.105.895-2 2-2v-1h12v1c1.105 0 2 .895 2 2v1c0 1.105-.895 2-2 2z",
    fill: "#ffc33e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m57 49h-12c-1.105 0-2-.895-2-2v-1c0-1.105.895-2 2-2v-1h12v1c1.105 0 2 .895 2 2v1c0 1.105-.895 2-2 2z",
    fill: "#f4ad3b"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m57 44h-12c-1.105 0-2-.895-2-2v-1c0-1.105.895-2 2-2v-1h12v1c1.105 0 2 .895 2 2v1c0 1.105-.895 2-2 2z",
    fill: "#ffc33e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m57 39h-12c-1.105 0-2-.895-2-2v-1c0-1.105.895-2 2-2v-1h12v1c1.105 0 2 .895 2 2v1c0 1.105-.895 2-2 2z",
    fill: "#f4ad3b"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#ffc33e",
    height: 5,
    rx: 2,
    width: 16,
    x: 43,
    y: 29
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m59 2.14-.736 9.749c-.072.956-1.232 1.388-1.912.711l-2.362-2.35-.003.003-21.87 21.87c-1.09 1.09-2.83 1.18-4.02.2l-8.9-7.28-13.53 13.53c-.569.569-1.501.569-2.07 0l-2.17-2.17c-.569-.569-.569-1.501 0-2.07l15.45-15.45c1.09-1.09 2.83-1.18 4.02-.2l8.9 7.28 19.95-19.95-2.368-2.368c-.666-.666-.245-1.806.694-1.879l9.783-.762c.649-.051 1.191.49 1.141 1.139",
    fill: "#42ad72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfit);
export default __webpack_public_path__ + "static/media/profit.1631c368957a143d7cf1c3e62de39bf5.svg";
export { ForwardRef as ReactComponent };